// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"996ea45a","787":"ee648f41","840":"baaa9bb2","890":"0db039ae"}[chunkId] + ".chunk.js";
};